import { render, staticRenderFns } from "./treeTable.vue?vue&type=template&id=16ec6a6d"
import script from "./treeTable.vue?vue&type=script&lang=js"
export * from "./treeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports